import { useState } from 'react';
import { RevealBox, SectionLabel, SectionTitle, SectionSub } from './UI';

const cards = [
  { icon: '🎯', title: 'Personalised Expert Guidance', desc: 'One-on-one counselling with certified academic advisors who understand your career goals, eligibility, and ambitions — not just course catalogues.' },
  { icon: '🏛️', title: 'Government-Approved Programs', desc: 'Every program we offer is UGC-DEB approved and nationally recognised — valid for government jobs, private employment, and higher studies.' },
  { icon: '💰', title: 'Most Affordable Pathway', desc: 'Premium university degrees at accessible pricing. We help match your academic ambition with your budget — EMI options available.' },
  { icon: '⚡', title: 'Lightning-Fast Admissions', desc: 'Our streamlined process handles documentation, verification, and university submission. Enrolled in as little as 3 working days.' },
  { icon: '🌐', title: '100% Online & Flexible', desc: 'No commute. No rigid schedule. Study from anywhere in India with mobile-first, fully online programs built for the modern learner.' },
  { icon: '🚀', title: 'Career-Focused Outcomes', desc: 'Every course is handpicked for real-world impact. A degree should open doors — iGrade ensures it opens the right ones for your career.' },
  { icon: '🤝', title: 'PAN-India Support Network', desc: '30+ counsellors spread across India, supporting students from every state with regional language options and personalised attention.' },
  { icon: '🏆', title: 'Award-Winning Platform', desc: 'Recognised as one of India\'s top EdTech platforms — 4.9★ on Google, featured in national education rankings and industry awards.' },
];

export default function WhyIGrade() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="why" style={{ padding: '100px 6%', background: 'var(--white)' }}>
      <RevealBox>
        <SectionLabel>Why Choose Us</SectionLabel>
        <SectionTitle>Built for <em style={{ fontStyle:'italic', color:'var(--navy2)' }}>Ambitious Learners</em></SectionTitle>
        <SectionSub>From your first inquiry to graduation day, iGrade is your dedicated partner in online higher education.</SectionSub>
      </RevealBox>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 20, marginTop: 56,
      }}>
        {cards.map((c, i) => (
          <RevealBox key={c.title} delay={i * 0.06}>
            <div
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                background: hovered === i ? 'var(--navy)' : 'var(--white)',
                border: `1.5px solid ${hovered === i ? 'var(--navy)' : 'var(--graylt)'}`,
                borderRadius: 'var(--radius)', padding: '36px 30px',
                transition: 'all 0.35s cubic-bezier(0.22,1,0.36,1)',
                transform: hovered === i ? 'translateY(-6px)' : 'translateY(0)',
                boxShadow: hovered === i ? 'var(--shadow-lg)' : 'none',
                cursor: 'default', position: 'relative', overflow: 'hidden',
              }}
            >
              {/* Bottom yellow bar */}
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0, height: 3,
                background: 'var(--yellow)',
                transform: hovered === i ? 'scaleX(1)' : 'scaleX(0)',
                transition: 'transform 0.35s ease',
                transformOrigin: 'left',
              }} />
              <div style={{
                width: 54, height: 54, borderRadius: 12,
                background: hovered === i ? 'rgba(245,197,24,0.15)' : 'var(--yellow3)',
                display: 'grid', placeItems: 'center', fontSize: 24, marginBottom: 18,
                transition: 'background 0.3s',
              }}>{c.icon}</div>
              <h3 style={{
                fontSize: 18, fontFamily: 'DM Sans,sans-serif', fontWeight: 700,
                color: hovered === i ? '#fff' : 'var(--navy)', marginBottom: 10, transition: 'color 0.3s',
              }}>{c.title}</h3>
              <p style={{
                fontSize: 14.5, color: hovered === i ? 'rgba(255,255,255,0.72)' : 'var(--gray)',
                lineHeight: 1.68, transition: 'color 0.3s',
              }}>{c.desc}</p>
            </div>
          </RevealBox>
        ))}
      </div>
    </section>
  );
}
